export function decimals(value, props, skipZero = true) {
  const fd = getMaxDecimalValue(props.forceDecimals);
  const md = getMaxDecimalValue(props.maxDecimals);
  value = +value;
  if (fd > -1) {
    value = value.toFixed(fd);
    if (md > -1 && md < fd) {
      const fDotIndex = value.indexOf('.');
      value = (+value).toFixed(md);
    }
    return value;
  } else if (md > -1) {
    value = (+value).toFixed(md);
    while (value.substring(value.length - 1) === '0') {
      value = value.substr(0, value.length - 1);
      if (value.substring(value.length - 1) === '.') {
        value = value.substr(0, value.length - 1);
        break;
      }
    }
  }
  return value + '';
}

function getMaxDecimalValue(value) {
  if (typeof value === 'string' && value) {
    return +value;
  } else if (typeof value === 'number' && !isNaN(value)) {
    return value;
  }
  return -1;
}

function applyMaxDecimals(value, md) {
  const dotIndex = value.indexOf('.');
  if (dotIndex !== -1) {
    const decs = value.length - dotIndex - 1;
    value = (+value).toFixed(md);
  }
  return value;
}

export function commas(value, commas = true) {
  value += '';
  if (commas) {
    let dotIndex = value.indexOf('.');
    if (dotIndex === -1) {
      dotIndex = value.length;
    }
    value = [
      value.substr(0, dotIndex).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      value.substr(dotIndex)
    ].join('');
  }
  return value;
}

// Returns a useful number that corresponds to a divisor string.
export function getDivisor(unit) {
  switch (unit) {
    case 'hundreds':
      return 100;
    case 'thousands':
      return 1000;
    case 'millions':
      return 1000000;
    case 'billions':
      return 1000000000;
    case 'trillions':
      return 1000000000000;
  }
  return 1;
}

export function applyFull(value, props, isPie = false, skipZero = true, tooltipOrAnnotation = false) {
  if (tooltipOrAnnotation) {
    let splitDecimals = value.toString().split('.');
    splitDecimals = splitDecimals.length > 1 ? splitDecimals[1].length : 0;
    if (Number(splitDecimals) >= 3 && props.prefix === '') {
      props.forceDecimals = '3';
    }
    if (props.prefix !== '') {
      props.forceDecimals = splitDecimals > 0 ? '2' : '0';
    } else {
      props.forceDecimals = splitDecimals;
    }
    props.maxDecimals = '3';
  }
  value = decimals(value, props);
  value = commas(value, props.commas);
  if (isPie) {
    value += '%';
  } else {
    if (value.charAt(0) === '-') {
      value = props.prefix !== undefined ? `-${props.prefix}${value.substr(1)}` : `${value.substr(1)}` ;
    } else {
      value = props.prefix !== undefined ? `${props.prefix}${value}` : `${value}`;
    }
    value += props.suffix;
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/chart/data/format.js